module.exports = __webpack_public_path__ + "img/slide-1.e0b53070.jpg";